
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Color, colorClass } from '../model/colors';
import { toGrid, emptyGrid } from '../model/canvas';
import database from '../database';
import firebase from 'firebase/app';

@Component
export default class Canvas extends Vue {

  @Prop()
  public penColor: Color = 0;

  public data = {
    canvasDepth: 1,
    canvas: [] as Array<Array<number|undefined>>,
  };

  public colorClass = colorClass;

  public setPixelColor(row: number, column: number, color: Color) {
    const xOffsets = row.toString(2).padStart(this.data.canvasDepth, '0');
    const yOffsets = column.toString(2).padStart(this.data.canvasDepth, '0');
    let pixelRef = this.placeRef.child('canvas');
    for (let i = 0; i < this.data.canvasDepth; i++) {
      pixelRef = pixelRef.child(xOffsets[i] + yOffsets[i]);
    }
    pixelRef.set(color);

    // Save history
    const historyRef =  this.placeRef.child('history');
    const historyItemRef = historyRef.push();
    historyItemRef.set({
      x: column,
      y: row,
      value: color,
      timestamp: firebase.database.ServerValue.TIMESTAMP,
    });
  }

  protected mounted() {
    this.placeRef.child('depth').once('value', (snapshot: firebase.database.DataSnapshot) => {
      this.data.canvasDepth = snapshot.val();
      this.placeRef.child('canvas').on('value', this.onCanvasUpdated);
    });
  }

  protected destroyed() {
    this.placeRef.child('canvas').off('value', this.onCanvasUpdated);
  }

  private onCanvasUpdated(snapshot: firebase.database.DataSnapshot) {
    if (!snapshot.exists()) {
      console.warn('Canvas does not exist', this.canvasId);
      return;
    }

    this.data.canvas = toGrid<number>(snapshot.val(), emptyGrid(Math.pow(2, this.data.canvasDepth)));
  }

  private canvasId = 'the-one-and-only';
  private placeRef = database.ref('canvas').child(this.canvasId);
}
